<template>
  <div class="page-detecteurs">
    <landing-header />

    <main>
      <section class="hero-detecteurs">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-securite">Sécurité & Conformité</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Zéro défaut sur vos <br />
              <span class="gradient-text">détecteurs de gaz</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Ne laissez plus un étalonnage périmé bloquer votre activité. Termoflow anticipe vos échéances et garantit que chaque intervention est réalisée avec un matériel certifié.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="calibration-card shadow-2xl">
              <div class="card-status warning">
                <i class="fa-solid fa-triangle-exclamation"></i> Étalonnage requis sous 15 jours
              </div>
              <div class="card-details">
                <div class="dev-info">
                  <span class="dev-name">Détecteur Inficon D-TEK</span>
                  <span class="dev-id">SN: 788-2024-X</span>
                </div>
                <div class="dev-meta">
                  <div class="meta-item">
                    <p>Dernier contrôle</p>
                    <strong>12/05/2023</strong>
                  </div>
                  <div class="meta-item">
                    <p>Technicien</p>
                    <strong>Thomas D.</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-900 text-white overflow-hidden">
        <div class="max-w-7xl mx-auto px-4">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            <div class="alert-feature">
              <div class="alert-icon"><i class="fa-solid fa-bell"></i></div>
              <h3 class="text-xl font-bold mb-4">Alertes Échéances</h3>
              <p class="text-gray-400">Recevez des notifications automatiques avant que vos appareils ne deviennent non-conformes.</p>
            </div>
            <div class="alert-feature">
              <div class="alert-icon"><i class="fa-solid fa-user-gear"></i></div>
              <h3 class="text-xl font-bold mb-4">Affectation Nominative</h3>
              <p class="text-gray-400">Sachez à tout moment quel technicien dispose de quel matériel pour une meilleure responsabilisation.</p>
            </div>
            <div class="alert-feature">
              <div class="alert-icon"><i class="fa-solid fa-clipboard-check"></i></div>
              <h3 class="text-xl font-bold mb-4">Lien avec les CERFA</h3>
              <p class="text-gray-600 text-gray-400">L'appareil utilisé est automatiquement reporté sur les documents réglementaires de l'intervention.</p>
            </div>
          </div>
        </div>
      </section>

      <!-- <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-20">
          <div class="lg:w-1/2 order-2 lg:order-1">
             <div class="mobile-demo-ui shadow-xl">
               <div class="ui-header-app">Détails Équipement</div>
               <div class="ui-status-badge green">Certificat Valide</div>
               <div class="ui-content-list">
                 <div class="ui-row"><span>Modèle</span><strong>D-TEK 3</strong></div>
                 <div class="ui-row"><span>Échéance</span><strong>24/11/2026</strong></div>
               </div>
             </div>
          </div>
          <div class="lg:w-1/2 order-1 lg:order-2">
            <h2 class="text-3xl font-bold text-gray-900 mb-6">Le contrôle au bout des doigts</h2>
            <p class="text-gray-600 mb-8">Depuis l'application mobile, vos techniciens vérifient la validité de leur détecteur avant de commencer. Une sécurité renforcée pour eux comme pour vos clients.</p>
            <ul class="check-list-pro">
              <li><i class="fa-solid fa-circle-check"></i> Consultation du matériel affecté</li>
              <li><i class="fa-solid fa-circle-check"></i> Vérification de la date limite de validité</li>
              <li><i class="fa-solid fa-circle-check"></i> Association directe à l'intervention</li>
            </ul>
          </div>
        </div>
      </section> -->

      <section class="py-24 bg-gray-50 border-t border-gray-100">
        <div class="max-w-4xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold mb-8 text-gray-900">Une traçabilité prête pour l'audit</h2>
          <p class="text-gray-600 mb-12 text-lg leading-relaxed">
            Chaque détecteur dispose d'un historique complet : affectations successives, interventions associées et certificats d'étalonnage. En cas de contrôle, vous extrayez vos preuves en quelques secondes.
          </p>
          <div class="audit-stats-grid">
            <div class="a-stat">
              <span class="a-val">100%</span>
              <span class="a-lab">Équipements tracés</span>
            </div>
            <div class="a-stat">
              <span class="a-val">0</span>
              <span class="a-lab">Oubli d'étalonnage</span>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="bg-orange-600 rounded-[3rem] p-12 text-white shadow-2xl relative overflow-hidden">
             <div class="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
               <div class="ben-item">
                 <h4 class="font-bold mb-2">Conformité</h4>
                 <p class="text-sm opacity-80">Réglementation F-Gaz respectée à la lettre.</p>
               </div>
               <div class="ben-item">
                 <h4 class="font-bold mb-2">Anticipation</h4>
                 <p class="text-sm opacity-80">Plus de stress de dernière minute.</p>
               </div>
               <div class="ben-item">
                 <h4 class="font-bold mb-2">Crédibilité</h4>
                 <p class="text-sm opacity-80">Gage de sérieux auprès de vos clients.</p>
               </div>
               <div class="ben-item">
                 <h4 class="font-bold mb-2">Sérénité</h4>
                 <p class="text-sm opacity-80">Prêt pour tous les contrôles.</p>
               </div>
             </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-8">Sécurisez votre parc d'équipements</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'DetecteursPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-detecteurs {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fff7ed, transparent 35%);
}

.badge-securite {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #fef2f2;
  color: #dc2626;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  border: 1px solid #fee2e2;
}

/* --- CALIBRATION CARD --- */
.calibration-card {
  background: white;
  border-radius: 2rem;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
.card-status.warning {
  background: #fff7ed;
  color: #c2410c;
  padding: 1rem;
  text-align: center;
  font-weight: 800;
  font-size: 0.85rem;
  border-bottom: 1px solid #fed7aa;
}
.card-details { padding: 2.5rem; }
.dev-name { display: block; font-weight: 900; font-size: 1.2rem; color: #1f2937; margin-bottom: 0.25rem; }
.dev-id { color: #9ca3af; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; }
.dev-meta { display: grid; grid-cols: 2; gap: 2rem; margin-top: 2rem; border-top: 1px solid #f3f4f6; padding-top: 2rem; }
.meta-item p { font-size: 0.7rem; color: #9ca3af; text-transform: uppercase; font-weight: 800; margin-bottom: 0.25rem; }
.meta-item strong { color: #1f2937; }

/* --- FEATURES DARK --- */
.alert-icon { font-size: 2.5rem; color: #f97316; margin-bottom: 1.5rem; }
.alert-feature { text-align: center; }

/* --- MOBILE UI --- */
.mobile-demo-ui {
  max-width: 300px;
  background: #f8fafc;
  border-radius: 2.5rem;
  padding: 1.5rem;
  border: 8px solid #1e293b;
  margin: 0 auto;
}
.ui-header-app { text-align: center; font-weight: 900; font-size: 0.9rem; margin-bottom: 1.5rem; color: #1e293b; }
.ui-status-badge { text-align: center; padding: 0.5rem; border-radius: 0.5rem; font-weight: 800; font-size: 0.75rem; margin-bottom: 2rem; }
.ui-status-badge.green { background: #dcfce7; color: #166534; }
.ui-row { display: flex; justify-content: space-between; padding: 0.75rem 0; border-bottom: 1px solid #e2e8f0; font-size: 0.8rem; }
.ui-row span { color: #64748b; font-weight: 700; }

/* --- LIST --- */
.check-list-pro { list-style: none; padding: 0; }
.check-list-pro li { display: flex; align-items: center; gap: 1rem; font-weight: 700; color: #4b5563; margin-bottom: 1rem; }
.check-list-pro li i { color: #f97316; }

/* --- AUDIT STATS --- */
.audit-stats-grid { display: flex; justify-content: center; gap: 4rem; margin-top: 2rem; }
.a-val { display: block; font-size: 3rem; font-weight: 900; color: #f97316; }
.a-lab { font-weight: 800; color: #9ca3af; text-transform: uppercase; font-size: 0.8rem; }

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

@media (max-width: 1024px) {
  .hero-detecteurs { text-align: center; padding-top: 8rem; }
  .hero-detecteurs .flex { flex-direction: column; }
  .calibration-card { margin-top: 4rem; }
}
</style>